var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c629a1fc144ba5c9644e0bff23fa95fc7e8eb8fd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"c629a1fc144ba5c9644e0bff23fa95fc7e8eb8fd"};
      